import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
@Component({
  standalone:false,
  selector: 'app-notification-template',
  templateUrl: './notification-template.component.html',
})
export class NotificationTemplateComponent implements OnInit{

  notificationTemplates: any[] = [];
  cols: any[] = [
    { field: 'subject', header: 'Subject', filterType: 'text', width: '200px' },
    { field: 'name', header: 'Name', filterType: 'text', width: '200px' },
    { field: 'message', header: 'Message', filterType: 'text', width: '200px' },
    { field: 'html_message', header: 'HTML Message', filterType: 'text', width: '200px' }
  ];
  formData: any = {
    subject: '',
    name: '',
    message: '',
    html_message: '',
  };
  viewMode: boolean=false;
  showDialog: boolean = false;
  showDeleteDialog: boolean = false;
  dialogConfig: any = {
    title: 'Notification Template',
    formLayout: 'single-column',
    fields: [
      {
        key: 'subject',
        label: 'Subject',
        type: 'text',
        placeholder: 'Enter Subject',
        validation: {
          required: true,
        },
      },
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter Name',
        validation: {
          required: true,
        },
      },
      {
        key: 'message',
        label: 'Message',
        type: 'text',
        placeholder: 'Enter Message',
        validation: {
          required: true,
        },
      },
      {
        key: 'html_message',
        label: 'HTML Message',
        type: 'text-editor',
        placeholder: 'Enter HTML Message',
        
      },
    ],
  };
  canEditSetup: boolean = false;
  title: string = 'Notification Template Master';
  constructor(private apiService: ApiService, private messageService: MessageService) {
  }

  ngOnInit(): void {
  }
  screenVisibility:boolean = true;
  getNotificationTemplate(): void {
    this.screenVisibility = false;
    setTimeout(() => {
      this.screenVisibility = true;
    }, 100);
  }


  addNotificationTemplate(): void {
    this.formData = {
      subject: '',
      name: '',
      message: '',
      html_message: '',
    };
    this.viewMode = false;
    this.showDialog = true;
  }

  onSubmitNotificationTemplate(event: any): void {
    console.log(event);
    const payload = {
      subject: event.subject,
      name: event.name,
      message: event.message,
      html_message: event.html_message,
    };
    if(this.currentRowSelected && this.currentRowSelected.id){
      payload['id'] = this.currentRowSelected.id;
      payload['action'] = 'update';
    } else {
      payload['action'] = 'create';
    }
      this.apiService.postAPI(`/notification/templates/`, payload)
        .subscribe((res: any) => {
          if (res) {
            this.showDialog = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Notification Template added successfully'
            });
            this.getNotificationTemplate();
          }
        });
    
  }

  onCancelNotificationTemplate(): void {
    this.showDialog = false;
  }

  onCloseNotificationTemplate(): void {
    this.showDialog = false;
  }
  currentRowSelected:any;
  onUpdateNotificationTemplate(event: any): void {
    this.currentRowSelected = event;
    this.formData = {
      subject: event.subject,
      name: event.name,
      message: event.message,
      html_message: event.html_message,
    };
    this.viewMode = false;
    this.showDialog = true;
  }

  onDeleteNotificationTemplate(): void {
    this.apiService.postAPI(`/notification/templates/`, {id: this.currentRowSelected.id, delete:true})
      .subscribe((res: any) => {
        if (res) {
          this.showDeleteDialog = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Notification Template deleted successfully'
          });
          this.getNotificationTemplate();
        }
      });
  }

  

  showDeleteNotificationTemplate(event: any): void {
    this.currentRowSelected = event;
    console.log(event);
    this.showDeleteDialog = true;
  }


  viewNotificationTemplate(event: any): void {
    this.formData = {
      subject: event.subject,
      name: event.name,
      message: event.message,
      html_message: event.html_message,
    };
    this.viewMode = true;
    this.showDialog = true;
  }
}
